import { render, staticRenderFns } from "./Comisiones.vue?vue&type=template&id=40f660c8"
import script from "./Comisiones.vue?vue&type=script&lang=ts"
export * from "./Comisiones.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports